import React, { FC } from 'react';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
// services
import AuthService from 'src/services/AuthService';
// import { CompanyForm } from 'src/components/forms';
import cookie from 'js-cookie';
// material ui
import {
  AppBar,
  Toolbar,
  IconButton,
  makeStyles,
  createStyles,
  Theme,
  Box,
  Menu,
  MenuItem,
  Card,
  CardContent,
  CardActions,
  // DialogTitle,
  Typography,
  Button
} from '@mui/material';
import fade from '@mui/material/Fade';
// import MenuIcon from '@material-ui/icons/Menu';
// import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import { KeyboardArrowDown, KeyboardArrowUp, Search, Home as HomeIcon, CheckCircle, Close } from '@mui/icons-material';
// import MuiDialogTitle from '@mui/material/DialogTitle';

const drawerWidth = 240;
const authService = new AuthService();

export interface DialogTitleProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}
// const DialogTitle = (props: DialogTitleProps) => {
//   const { children, onClose, ...other } = props;
//   return (
//     <MuiDialogTitle disableTypography className="dialog-header" {...other}>
//       <Typography variant="h6">{children}</Typography>
//       {onClose ? (
//         <IconButton aria-label="close" className="closeButton" onClick={onClose}>
//           <Close style={{ color: 'white' }} />
//         </IconButton>
//       ) : null}
//     </MuiDialogTitle>
//   );
// };



// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     appBar: {
//       zIndex: theme.zIndex.drawer + 1,
//       boxShadow: 'none',
//       transition: theme.transitions.create(['width', 'margin'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//       }),
//     },
//     appBarShift: {
//       marginLeft: drawerWidth,
//       width: `calc(100% - ${drawerWidth}px)`,
//       transition: theme.transitions.create(['width', 'margin'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//     },
//     menuButton: {
//       marginRight: 36,
//     },
//     search: {
//       padding: '0 12px',
//       position: 'relative',
//       minHeight: '50px',
//       '&:hover': {
//         backgroundColor: fade(theme.palette.common.white, 0.25),
//       },
//       width: '100%',
//       borderLeft: '1px solid rgba(255,255,255,0.2)',
//       [theme.breakpoints.up('sm')]: {
//         marginLeft: 'auto',
//         width: 'auto',
//       },
//     },
//     inputRoot: {
//       color: 'inherit',
//     },
//     inputInput: {
//       transition: theme.transitions.create('width'),
//       width: '100%',
//       [theme.breakpoints.up('md')]: {
//         width: '8ch',
//       },
//     },
//     sectionDesktop: {
//       display: 'none',
//       marginLeft: 'auto',
//       width: 'auto',
//       [theme.breakpoints.up('md')]: {
//         display: 'flex',
//         justifyContent: 'flex-end',
//       },
//     },
//     sectionMobile: {
//       display: 'flex',
//       marginLeft: 'auto',
//       [theme.breakpoints.up('md')]: {
//         display: 'none',
//       },
//     },
//     menuItem: { fontSize: '14px' },
//   })
// );

export interface IDashboardHeaderProps {
  handleDrawerOpen?: () => void;
  open?: boolean;
}

const DashboardHeader: FC<IDashboardHeaderProps> = (props) => {
  // props speading
  const { open } = props;
  const [profileMenu, setProfileMenu] = React.useState(null);
  const [settingsMenu, setSettingsMenu] = React.useState(null);
  const [userName, setuserName] = React.useState(null);
  const [handletrigger, setHandletrigger] = React.useState(false);
  const [openeaddcompany, setOpenaddcompany] = React.useState(false);
  const [openeditcompany, setOpeneditcompany] = React.useState(false);
  const [open_map_com_pro, setOpen_map_comp_pro] = React.useState(false);
  const [open_map_com_client, setOpen_map_comp_client] = React.useState(false);
  const [open_map_prod_client, setOpen_map_prod_client] = React.useState(false);
  const [open_map_crawler, setOpen_map_crawler] = React.useState(false);
  const [openCreateUser, setOpenCreateUser] = React.useState(false);

  const [showSuccess, setShowSuccess] = React.useState(false);


  const navigate = useNavigate();
  // const classes = useStyles();
  const menuId = 'primary-search-account-menu';

  React.useEffect(() => {
    if (cookie.get('accessToken') && cookie.get('username')) {
      setuserName(cookie.get('username'));
    } else {
      // Router.push('/auth/signin');
      navigate('/auth/signin');
    }
  });
  const handleMenu = (event: any, setState) => {
    setState(event.currentTarget);
  };
  const handleClose = (setState) => {
    setState(null);
  };
  const handleLogout = () => {
    cookie.remove('accessToken');
    // authService.logout();
    navigate('/auth/signin');
  };

  const SaveAndFiling = (data: any) => {
    console.log(data)
  };

  const handleModalClose = (setState, value) => {

    // setState(false);
    // setOpeneditcompany(false)
    setShowSuccess(true);
  };

  const handleCancel = (setState, value) => {
    setShowSuccess(false);
    setState(value);
  };
  const adminusers = ['vijay@almug.ai', 'amruth@almug.ai', 'mohan@factstream.ai', 'rajakumari@factstream.ai', 'alekya@almug.ai', 'deva@almug.ai', 'mounya@almug.ai']
  const superadmin = ['vijay@almug.ai']


  const SuccessMessage = () => {
    return (
      <>
        <Card>
          <CardContent>
            <Box justifyContent="center">
              <Box display="flex" justifyContent="center" className="mt-3 mb-3">
                <CheckCircle style={{ color: '#7EC17B', fontSize: '150px' }} />
              </Box>
              <Box display="flex" justifyContent="center" className="mt-3 mb-3">
                <Typography className="success-text">Updated Successfully!</Typography>
              </Box>
            </Box>
          </CardContent>
          <CardActions>
            <Box display="flex" justifyContent="center" className="w-100 pb-4">
              <Button
                variant="outlined"
                size="large"
                className="roundButton"
                onClick={() => {
                  setOpeneditcompany(false);
                  handleModalClose(false, false);
                  setShowSuccess(false);
                  window.location.reload();
                }}
              >
                Close
              </Button>
            </Box>
          </CardActions>
        </Card>
      </>
    );
  };

  return (
    <AppBar
      position="fixed"
      // className={clsx(classes.appBar, {
      //   [classes.appBarShift]: open,
      // })}
    >
      <Toolbar className="menuToolbar justify-content-between">
        {/* <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, {
            hide: open,
          })}
        >
          <MenuIcon />
        </IconButton> */}
        {/* <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Link to={'/'}>
            <a style={{ color: '#fff', paddingRight: '16px' }}>
              <HomeIcon />
            </a>
          </Link>
        </div> */}
        <div className='brand-text' style={{ textDecoration: 'none' }}>
          <Link to={'/'}>
            <img className="logo" src="/us-indenture.png" title="UsIndenture" />
          </Link>
        </div>



        <div 
          // className={classes.sectionDesktop}
          className='d-flex'
        >
          {/* <Box className={classes.search} display="flex" alignItems="center">
            
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              endAdornment={
                <InputAdornment position="end">
                  <Search className="iconColor" />
                </InputAdornment>
              }
            />
          </Box>
          <Box className="notification" display="flex" alignItems="center">
            <IconButton
              aria-label="show 3 new notifications"
              color="inherit"
              style={{ padding: '0 12px' }}
            >
              <Badge badgeContent={3} color="primary" className="badge">
                <NotificationsIcon className="notificationIcon" />
              </Badge>
            </IconButton>
          </Box> */}
          <Box>
            <Link to={'/'} style={{ textDecoration: 'none' }}>
              <div style={{ color: '#01acee', fontSize: '12px', padding: '16px' }}>Home</div>
            </Link>
          </Box>
          {/* {adminusers.includes(cookie.get('username')) ? (
            <Box className="notification" display="flex" alignItems="center">
              <IconButton
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={(e) => handleMenu(e, setSettingsMenu)}
                color="inherit"
                style={{ padding: '0 5px', color: '#ADCDF0' }}
              >
                <SettingsIcon />
              </IconButton>

              <Menu
                id="simple-menu"
                anchorEl={settingsMenu}
                keepMounted
                open={Boolean(settingsMenu)}
                onClose={(e) => handleClose(setSettingsMenu)}
                elevation={1}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <MenuItem className={classes.menuItem} onClick={() => setOpenaddcompany(true)}>Add Company</MenuItem>
                <MenuItem className={classes.menuItem} onClick={() => setOpeneditcompany(true)}>Edit Company</MenuItem>
                <MenuItem className={classes.menuItem} onClick={() => setOpen_map_comp_pro(true)}>Map Company to Product</MenuItem>
                <MenuItem className={classes.menuItem} onClick={() => setOpen_map_comp_client(true)}>Map Company to Client</MenuItem>
                <MenuItem className={classes.menuItem} onClick={() => setOpen_map_crawler(true)}>Map Crawler</MenuItem>
                {superadmin.includes(cookie.get('username')) ? (
               <MenuItem className={classes.menuItem} onClick={() => setOpenCreateUser(true)}>Create User</MenuItem>):('')}
             </Menu>
            </Box>
          ) : ('')} */}
          <Box className="userInfo">
            <div className="content-justify">
              <img src="/user.jpg" className="userImage"></img>
            </div>
            <div className="content-justify">
              <span className="user"> Welcome {userName}</span>
            </div>
            <div className="content-justify">
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={(e) => handleMenu(e, setProfileMenu)}
                color="inherit"
                style={{ padding: '0 5px', color: '#ADCDF0' }}
              >
                {profileMenu ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            </div>
            <Menu
              id="simple-menu"
              anchorEl={profileMenu}
              keepMounted
              open={Boolean(profileMenu)}
              onClose={(e) => handleClose(setProfileMenu)}
              elevation={1}
              // getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <MenuItem 
                // className={classes.menuItem}
              >
                My Account
              </MenuItem>
              <MenuItem 
                // className={classes.menuItem} 
                onClick={handleLogout}
              >
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </div>
        {/* <div 
          className={classes.sectionMobile}
        >
          <IconButton aria-label="show more" aria-haspopup="true" color="inherit">
            <MoreIcon className="iconColor" />
          </IconButton>
        </div> */}
      </Toolbar>
      {/* <Dialog
        className="dialog-form"
        open={openeditcompany}
        // onClose={() => setOpeneditcompany(false)}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setOpeneditcompany(false)
          }
        }}
        aria-labelledby="form-dialog-title"
      >
        {showSuccess ? (
          <SuccessMessage />
        ) : (
          <>
            <DialogTitle  id="form-dialog-title"  onClose={() => handleCancel(setOpeneditcompany, false)} 
            // onClose={() => setOpeneditcompany(false)} 
            >
              Edit Company
            </DialogTitle>
            <DialogContent>
              <CompanyForm
                SaveAndFiling={SaveAndFiling}
                handleClose={() => handleModalClose(setOpeneditcompany, false)}
                handleCancel={() => handleCancel(setOpeneditcompany, false)}
                isaddmode={false}
                company_details={null}
                handletrigger={handletrigger}
                setHandletrigger={setHandletrigger}
                admin={true}
              />
            </DialogContent>
          </>
        )}
      </Dialog>

      <Dialog
        className="dialog-form"
        open={openeaddcompany}
        // onClose={() => setOpenaddcompany(false)}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setOpenaddcompany(false)
          }
        }}
        aria-labelledby="form-dialog-title"
      >
        {showSuccess ? (
          <SuccessMessage />
        ) : (
          <>
            <DialogTitle  id="form-dialog-title"  onClose={() => handleCancel(setOpenaddcompany, false)}>
              Add Company
            </DialogTitle>
            <DialogContent>
              <CompanyForm
                SaveAndFiling={SaveAndFiling}
                handleClose={() => handleModalClose(setOpenaddcompany, false)}
                handleCancel={() => handleCancel(setOpenaddcompany, false)}
                isaddmode={true}
                company_details={null}
                handletrigger={handletrigger}
                setHandletrigger={setHandletrigger}
                admin={true}
              />
            </DialogContent>
          </>
        )}
      </Dialog> */}











    </AppBar>
  );
};


export default DashboardHeader;
